import { createFocusTrap, FocusTrap } from 'focus-trap'

class Service {
  trap: FocusTrap | null = null
  previous: HTMLElement | null = null

  setContainer = (element: Element | null) => {
    if (!element) return

    this.previous = document.activeElement as HTMLElement

    setTimeout(() => {
      this.trap = createFocusTrap(element as HTMLElement, { allowOutsideClick: true, delayInitialFocus: true })
      this.trap.activate()
    })
  }

  reset = () => {
    setTimeout(() => {
      this.previous?.focus()
      this.trap?.deactivate()
      this.trap = null
    })
  }
}

const FocusService = new Service()

export default FocusService
